import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "viewport rel" }
const _hoisted_2 = {
  class: "abs-wrap",
  style: {"padding":"0 30px","z-index":"1","top":"40px"}
}
const _hoisted_3 = {
  key: 0,
  style: {"height":"34px"}
}

import Index from './Index.vue'
import ScTabs from './country/tabs.vue'
import { isMultiStore } from '@/store'
import { sourceCountryRef } from './country'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const membership = store.getters.membership

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rel", {'no-vip-kr-style': _unref(membership).templateLevel === 0 && _unref(isMultiStore)()}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(isMultiStore)())
          ? (_openBlock(), _createBlock(ScTabs, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(Index, { key: _unref(sourceCountryRef) }, {
      default: _withCtx(() => [
        (_unref(isMultiStore)())
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})